import { Amplify } from 'aws-amplify';

const resolveHostedUiDomain = (): string => {
  const configuredDomain = process.env.REACT_APP_COGNITO_DOMAIN || '';
  if (!configuredDomain) {
    return '';
  }

  if (configuredDomain.includes('.')) {
    return configuredDomain;
  }

  const userPoolId = process.env.REACT_APP_COGNITO_USER_POOL_ID || '';
  const region = userPoolId.split('_')[0];
  if (!region) {
    return configuredDomain;
  }

  return `${configuredDomain}.auth.${region}.amazoncognito.com`;
};

const resolveRedirectUrl = (): string => {
  const configuredRedirectUrl = process.env.REACT_APP_REDIRECT_URL || 'http://localhost:3000';

  if (typeof window === 'undefined') {
    return configuredRedirectUrl;
  }

  const currentOrigin = window.location.origin;
  const isLocalOrigin =
    window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

  if (!isLocalOrigin) {
    return currentOrigin;
  }

  return configuredRedirectUrl;
};

const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || '',
      userPoolClientId: process.env.REACT_APP_COGNITO_USER_POOL_CLIENT_ID || '',
      identityPoolId: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID || '',
      loginWith: {
        oauth: {
          domain: resolveHostedUiDomain(),
          scopes: ['email', 'openid', 'profile'],
          redirectSignIn: [resolveRedirectUrl()],
          redirectSignOut: [resolveRedirectUrl()],
          responseType: 'code'
        }
      }
    }
  },
  ssr: false
} as const;

Amplify.configure(awsConfig as any);

export default awsConfig;
